// rijHelpers.js
  import { KOELTIJD_SECONDEN } from "../constants";
 
export const toJsDate = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === "function") return value.toDate();
  if (value instanceof Date) return value;

  const seconds = value?.seconds ?? value?._seconds;
  const nanoseconds = value?.nanoseconds ?? value?._nanoseconds ?? 0;
  if (Number.isFinite(Number(seconds))) {
    return new Date(Number(seconds) * 1000 + Number(nanoseconds) / 1_000_000);
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const isRijHandmatigBezet = (rij) => rij?.handmatigBezet === true;

export const rijHelpers = {
  getRijStatus: (rij) => {
    if (!rij.partij) return "";
    const now = Date.now();
    const diffSeconden = (now - toJsDate(rij.datumIn)) / 1000;
    return diffSeconden >= KOELTIJD_SECONDEN ? "gekoeld" : "warm";
  },

  rijHeeftWarmeBuur: (rij, rijenState, excludeRijId = null) => {
    // Select relevant motor/koelcel rows
    const motorRijen =
      rij.koelcel === "6"
        ? rijenState.filter(r => r.koelcel === "6")
        : rijenState.filter(r => r.koelcel === rij.koelcel && r.motor ===    rij.motor);

    const index = motorRijen.findIndex(r => r.id === rij.id);
    const linksRij = motorRijen[index - 1];
    const rechtsRij = motorRijen[index + 1];

    const isBuurWarm = r => r && r.id !== excludeRijId && 
    rijHelpers.getRijStatus(r) === "warm";

    return isBuurWarm(linksRij) || isBuurWarm(rechtsRij);
  },

  kanRijPlaatsen: (rij, rijenState, kistToevoegen = 0, excludeRijId = null) => {
    if (isRijHandmatigBezet(rij)) return false;

    const rijStatus = rijHelpers.getRijStatus(rij);

    const wordtWarm =
      kistToevoegen > 0 ||
      rijStatus === "warm" ||
      (!rij.datumIn && rij.huidige_bezetting + kistToevoegen > 0);

    // Als rij warm wordt en er een buur warm is → niet toegestaan
    if (wordtWarm && rijHelpers.rijHeeftWarmeBuur(rij, rijenState, excludeRijId)) {
      return false;
    }

    return true;
  }
};

export function keyForRowLike(obj) {
  if (!obj) return "";
  return `${String(obj.koelcel).padStart(2, "0")}-${String(obj.rij).padStart(2, "0")}`;
}

export function compareRijNumbers(a, b) {
  const numericDifference = Number(a?.rij) - Number(b?.rij);
  if (Number.isFinite(numericDifference) && numericDifference !== 0) {
    return numericDifference;
  }

  return String(a?.rij ?? "").localeCompare(String(b?.rij ?? ""), "nl", {
    numeric: true,
  });
}

export function buildOccupiedKeyMap(rijenMap) {
  const map = new Map();
  const values = rijenMap?.values ? rijenMap.values() : [];
  for (const r of values) {
    const key = keyForRowLike(r);
    map.set(key, Number(r?.huidige_bezetting ?? 0));
  }
  return map;
}

export function formatShortNlDate(v) {
  const d = toJsDate(v);
  if (!d) return "";

  const months = [
    "jan","feb","mrt","apr","mei","jun",
    "jul","aug","sep","okt","nov","dec"
  ];

  const dag = d.getDate();          // 1..31, geen voorloopnul
  const maand = months[d.getMonth()]; // 0..11 → korte NL-naam

  return `${dag}-${maand}`;         // bv. "26-mei", "4-aug"
}
